import { NgModule } from '@angular/core';

import { MasterConfirmedMessageActions } from './master-confirmed-message.actions';

@NgModule({
  providers: [
    MasterConfirmedMessageActions
  ]
})
export class MasterConfirmedMessageActionsModule {}
